import { Inject, Pipe, PipeTransform } from 'ng-metadata/core';
import { element } from 'angular';

/**
 * @ngdoc filter
 * @name mwStripTags
 * @module mw.components.contentDocuments
 *
 * @param {string} [input] - The contents of the element you want to strip your tags from
 * @returns {string} The text content of the HTML element
 *
 * @description
 * `mwStripTags` takes the content from an HTML element that you are querying and returns it in text form
 */
@Pipe({
    name: 'mwStripTags'
})
export class StripTagsPipe implements PipeTransform {
    transform(input: string) {
        return element('<span>' + input  + '</span>').text();
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/shared/strip-tags.pipe.ts